import React from 'react'
import styled, { keyframes } from 'styled-components'

// import Logo from './ic-brand-color.svg'
import IcLogo from './ic-brand-color.component.svg'

const Loading = (props) => (
  <Wrapper {...props}>
    {/* <Spinner src={Logo} {...props} /> */}
    <SpinnerSvg {...props}>
      <IcLogo />
    </SpinnerSvg>
    {props.size !== 'small' && <Text />}
  </Wrapper>
)

const Scale = keyframes`
  from {
    transform: scale(1)
  }
  to {
    transform: scale(1.04545)
  }
`

// const Spinner = styled.img`
//   ${({ size }) => size === 'small' && `
//   width: 25px;
//   height: 25px;
// `}

// ${({ size }) => size !== 'small' && `
//   width: 65px;
//   height: 65px;
//   margin-bottom: 20px;
// `}

//   animation: ${Scale} .5s linear infinite;
// `

const SpinnerSvg = styled.div`
  ${({ size }) =>
    size === 'small' &&
    `
  width: 25px;
  height: 25px;
`}

${({ size }) =>
  size !== 'small' &&
  `
  width: 65px;
  height: 65px;
  margin-bottom: 20px;
`}

  animation: ${Scale} .5s linear infinite;
`

const Text = styled.span``

const Wrapper = styled.div`
  height: ${({ size }) => (size !== 'small' ? `calc(100% - 60px)` : `100%`)};
  ${({ size }) => size !== 'small' && `min-height: 500px;`}

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  ${({ noHeight }) =>
    noHeight &&
    `
    height: initial!important;
    min-height: initial!important;
  `}
`

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading/index.js